<section class="support-section" mat-dialog-content>
  <app-support-data (close)="close()" />
</section>
